import React, { useContext, useReducer, createContext } from 'react';
import produce from 'immer';
const TemplatesStateContext = createContext();
const TemplatesDispatchContext = createContext();

export const RESET = 'RESET';
export const CHANGE_NAME = 'CHANGE_NAME';
export const PREVIOUS_PAGE = 'PREVIOUS_PAGE';
export const NEXT_PAGE = 'NEXT_PAGE';
export const SET_PAGE = 'SET_PAGE';
export const SELECT = 'SELECT';
export const TOGGLE_CREATE = 'TOGGLE_CREATE';
export const HANDLE_SEARCH = 'HANDLE_SEARCH';
export const TOGGLE_TEMPLATE_DETAIL = 'TOGGLE_TEMPLATE_DETAIL';
export const SET_CURRENT_TEMPLATE = 'SET_CURRENT_TEMPLATE';
export const SELECT_ALL_CONTRACTS = 'SELECT_ALL_CONTRACTS';

const initialState = () => ({
    selected: [],
    createIsOpen: false,
    detailOpen: false,
    currentContract: {},
    isTemplate: true,
    templates: [],
    allChecked: false,
    meta: {
        search: 'name|',
        sortBy: 'updatedAt',
        sortDirection: '-1',
        perPage: 10,
        page: 1,
        total: 5,
        url: '/templates/all',
        listOnly: true,
        filter: 'active',
        recordId: '',
        searchTerm: '',
        pendingByMe: true
    }
})

const reducer = produce((draft, action) => {
    // eslint-disable-next-line default-case
    switch (action.type) {
        case TOGGLE_TEMPLATE_DETAIL:
            draft.detailOpen = !draft.detailOpen
            if (!draft.detailOpen) {
                draft.currentContract = {};
            }
            break;
        case HANDLE_SEARCH:
            draft.meta.search = action.search;
            break;
        case TOGGLE_CREATE:
            draft.createIsOpen = !draft.createIsOpen;
            break;
        case SELECT:
            if (draft.selected.includes(action._id))
                draft.selected = draft.selected.filter(s => s !== action._id)
            else
                draft.selected.push(action._id)
            draft.allChecked = draft.selected.length > 0 && draft.selected.length === draft.templates.length;
            break;
        case NEXT_PAGE:
            draft.meta.page = draft.meta.page + 1
            break;
        case PREVIOUS_PAGE:
            draft.meta.page = draft.meta.page - 1
            break;
        case SET_PAGE:
            draft.meta.page = action.page
            break;
        case CHANGE_NAME:
            draft.name = action.name
            draft.meta.page = 1
            break;
        case SET_CURRENT_TEMPLATE:
            draft.detailOpen = true;
            draft.currentContract = action.template;
            break;
        case SELECT_ALL_CONTRACTS:
            if (!draft.allChecked) {
                draft.selected = action.templates.map(c => c._id);
            } else {
                draft.selected = []
            }
            draft.allChecked = !draft.allChecked;
            break;
        case RESET:
            return initialState();
    }
}, {});


function TemplatesProvider({ children }) {
    const [state, dispatch] = useReducer(reducer, initialState());

    return (
        <TemplatesStateContext.Provider value={{ ...state }}>
            <TemplatesDispatchContext.Provider value={dispatch}>
                {children}
            </TemplatesDispatchContext.Provider>
        </TemplatesStateContext.Provider>
    )
}

function useTemplatesState() {
    const context = useContext(TemplatesStateContext)
    if (context === undefined) {
        throw new Error('useTemplatesState must be used within a TemplatesProvider')
    }
    return context
}

function useTemplatesDispatch() {
    const context = useContext(TemplatesDispatchContext)
    if (context === undefined) {
        throw new Error('useTemplatesDispatch must be used within a TemplatesProvider')
    }
    return context
}


function useTemplates() {
    return [useTemplatesState(), useTemplatesDispatch()]
}

export { TemplatesProvider, useTemplates, useTemplatesState, useTemplatesDispatch }
